/**
 * @generated SignedSource<<778e583d4cb2001d7d2d66b1fe8d9568>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GeneratedProblemStatusEnum = "active" | "inactive" | "%future added value";
export type Ordering = "ASC" | "ASC_NULLS_FIRST" | "ASC_NULLS_LAST" | "DESC" | "DESC_NULLS_FIRST" | "DESC_NULLS_LAST" | "%future added value";
export type ProblemGeneratorSchoolTypeEnum = "elementary_school" | "high_school" | "middle_school" | "%future added value";
export type ProblemGeneratorStatusEnum = "invalid" | "valid" | "%future added value";
export type ProblemGeneratorFilter = {
  AND?: ProblemGeneratorFilter | null;
  DISTINCT?: boolean | null;
  NOT?: ProblemGeneratorFilter | null;
  OR?: ProblemGeneratorFilter | null;
  activeProblemsCount_Gte?: number | null;
  activeProblemsCount_Lte?: number | null;
  assignedToId_Exact?: string | null;
  assignedToId_In?: ReadonlyArray<string> | null;
  assignedTo_Exists?: boolean | null;
  assignedTo_Exists_In?: ReadonlyArray<boolean> | null;
  publishedProblemsCount_Gte?: number | null;
  publishedProblemsCount_Lte?: number | null;
  schoolType_In?: ReadonlyArray<ProblemGeneratorSchoolTypeEnum> | null;
  search?: string | null;
  status_In?: ReadonlyArray<ProblemGeneratorStatusEnum> | null;
  unitAId_In?: ReadonlyArray<string> | null;
  unitBId_In?: ReadonlyArray<string> | null;
  unitCId_In?: ReadonlyArray<string> | null;
  unitDId_In?: ReadonlyArray<string> | null;
};
export type ProblemGeneratorOrder = {
  changed?: Ordering | null;
  created?: Ordering | null;
  id?: Ordering | null;
  modified?: Ordering | null;
  originalTask_UnitD_Order?: Ordering | null;
};
export type GeneratedProblemFilter = {
  AND?: GeneratedProblemFilter | null;
  DISTINCT?: boolean | null;
  NOT?: GeneratedProblemFilter | null;
  OR?: GeneratedProblemFilter | null;
  id?: string | null;
  id_Exact?: string | null;
  id_In?: ReadonlyArray<string> | null;
  id_Not_In?: ReadonlyArray<string> | null;
  problemGeneratorId_Exact?: string | null;
  status_Exact?: GeneratedProblemStatusEnum | null;
};
export type GeneratedProblemOrder = {
  created?: Ordering | null;
  id?: Ordering | null;
  modified?: Ordering | null;
};
export type ProblemGeneratorId_problemGeneratorQuery$variables = {
  filters?: ProblemGeneratorFilter | null;
  generatedProblemFilters?: GeneratedProblemFilter | null;
  generatedProblemOrder?: GeneratedProblemOrder | null;
  id: string;
  order?: ProblemGeneratorOrder | null;
};
export type ProblemGeneratorId_problemGeneratorQuery$data = {
  readonly problemGenerator: {
    readonly generatedProblems: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly task: {
            readonly id: string;
            readonly isDeleted: boolean;
            readonly sequence: number;
          } | null;
        };
      }>;
      readonly totalCount: number | null;
    };
    readonly id: string;
    readonly next: string | null;
    readonly originalTask: {
      readonly id: string;
      readonly problem: {
        readonly id: string;
        readonly problem: string | null;
        readonly solution: string | null;
      } | null;
      readonly sequence: number;
      readonly " $fragmentSpreads": FragmentRefs<"TaskDescriptionList_task">;
    };
    readonly previous: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"ProblemGeneratorActionsMutationButtonStack_problemGenerator" | "ProblemGeneratorDescriptionList_problemGenerator" | "ProblemGeneratorGeneratedProblemMutationActionsDialog_problemGenerator" | "ProblemGeneratorProblemGeneratorHistoryPaginator_problemGenerator">;
  };
};
export type ProblemGeneratorId_problemGeneratorQuery = {
  response: ProblemGeneratorId_problemGeneratorQuery$data;
  variables: ProblemGeneratorId_problemGeneratorQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filters"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "generatedProblemFilters"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "generatedProblemOrder"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "order"
},
v5 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = [
  {
    "kind": "Variable",
    "name": "filters",
    "variableName": "filters"
  },
  {
    "kind": "Variable",
    "name": "order",
    "variableName": "order"
  }
],
v8 = {
  "alias": null,
  "args": (v7/*: any*/),
  "kind": "ScalarField",
  "name": "previous",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": (v7/*: any*/),
  "kind": "ScalarField",
  "name": "next",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sequence",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "problem",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "solution",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isDeleted",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "filters",
      "variableName": "generatedProblemFilters"
    },
    {
      "kind": "Variable",
      "name": "order",
      "variableName": "generatedProblemOrder"
    }
  ],
  "concreteType": "GeneratedProblemConnection",
  "kind": "LinkedField",
  "name": "generatedProblems",
  "plural": false,
  "selections": [
    (v13/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "GeneratedProblemEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "GeneratedProblem",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v6/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Task",
              "kind": "LinkedField",
              "name": "task",
              "plural": false,
              "selections": [
                (v6/*: any*/),
                (v10/*: any*/),
                (v14/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v17 = [
  (v6/*: any*/),
  (v16/*: any*/)
],
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "picture",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "assignedTo",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    (v19/*: any*/),
    (v20/*: any*/),
    (v14/*: any*/)
  ],
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "assigned",
  "storageKey": null
},
v23 = [
  (v6/*: any*/)
],
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "Task",
  "kind": "LinkedField",
  "name": "originalTask",
  "plural": false,
  "selections": (v23/*: any*/),
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "difficulty",
  "storageKey": null
},
v26 = [
  {
    "kind": "Literal",
    "name": "order",
    "value": {
      "order": "DESC"
    }
  }
],
v27 = [
  (v6/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "unitATitle",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "unitBTitle",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "unitCTitle",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "description",
    "storageKey": null
  }
],
v28 = {
  "alias": null,
  "args": (v26/*: any*/),
  "concreteType": "UnitD",
  "kind": "LinkedField",
  "name": "unitDs",
  "plural": true,
  "selections": (v27/*: any*/),
  "storageKey": "unitDs(order:{\"order\":\"DESC\"})"
},
v29 = [
  (v6/*: any*/),
  (v25/*: any*/),
  (v28/*: any*/)
],
v30 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  }
],
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v32 = [
  (v31/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "before",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "after",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ProblemGeneratorId_problemGeneratorQuery",
    "selections": [
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "ProblemGenerator",
        "kind": "LinkedField",
        "name": "problemGenerator",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Task",
            "kind": "LinkedField",
            "name": "originalTask",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TaskProblem",
                "kind": "LinkedField",
                "name": "problem",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/)
                ],
                "storageKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "TaskDescriptionList_task"
              }
            ],
            "storageKey": null
          },
          (v15/*: any*/),
          {
            "args": [
              {
                "kind": "Variable",
                "name": "generatedProblemFilters",
                "variableName": "generatedProblemFilters"
              },
              {
                "kind": "Variable",
                "name": "generatedProblemOrder",
                "variableName": "generatedProblemOrder"
              }
            ],
            "kind": "FragmentSpread",
            "name": "ProblemGeneratorActionsMutationButtonStack_problemGenerator"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ProblemGeneratorDescriptionList_problemGenerator"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ProblemGeneratorProblemGeneratorHistoryPaginator_problemGenerator"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ProblemGeneratorGeneratedProblemMutationActionsDialog_problemGenerator"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v0/*: any*/),
      (v4/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "ProblemGeneratorId_problemGeneratorQuery",
    "selections": [
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "ProblemGenerator",
        "kind": "LinkedField",
        "name": "problemGenerator",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Task",
            "kind": "LinkedField",
            "name": "originalTask",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TaskProblem",
                "kind": "LinkedField",
                "name": "problem",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "problemType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "creationType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "answer",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "answerType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "answerChoiceCount",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v16/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Scrap",
                "kind": "LinkedField",
                "name": "scrap",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ScrapSource",
                    "kind": "LinkedField",
                    "name": "scrapSource",
                    "plural": false,
                    "selections": (v17/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v18/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "File",
                "kind": "LinkedField",
                "name": "aiFile",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "objectUrl",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ProblemGenerator",
                "kind": "LinkedField",
                "name": "problemGenerator",
                "plural": false,
                "selections": (v23/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "GeneratedProblem",
                "kind": "LinkedField",
                "name": "generatedProblem",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProblemGenerator",
                    "kind": "LinkedField",
                    "name": "problemGenerator",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v24/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v24/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isMigrated",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "migrationDifficultyNeedsReview",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DerivedTaskGroup",
                "kind": "LinkedField",
                "name": "derivedTaskGroups",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "kind",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "count",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Task",
                "kind": "LinkedField",
                "name": "migrationPair",
                "plural": false,
                "selections": (v23/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "labelingCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TaskLabeling",
                "kind": "LinkedField",
                "name": "firstLabeling",
                "plural": false,
                "selections": (v29/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TaskLabeling",
                "kind": "LinkedField",
                "name": "secondLabeling",
                "plural": false,
                "selections": (v29/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TaskLabeling",
                "kind": "LinkedField",
                "name": "finalLabeling",
                "plural": false,
                "selections": (v29/*: any*/),
                "storageKey": null
              },
              (v28/*: any*/),
              {
                "alias": null,
                "args": (v26/*: any*/),
                "concreteType": "UnitD",
                "kind": "LinkedField",
                "name": "publishedUnitDs",
                "plural": true,
                "selections": (v27/*: any*/),
                "storageKey": "publishedUnitDs(order:{\"order\":\"DESC\"})"
              },
              (v25/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "aiDifficulty",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TypingAutomationScript",
                "kind": "LinkedField",
                "name": "typingAutomationScript",
                "plural": false,
                "selections": (v17/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TaskHint",
                "kind": "LinkedField",
                "name": "hint",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "publishedText",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TaskSubmitFeedback",
                "kind": "LinkedField",
                "name": "submitFeedback",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "publishedSpecialAnswer",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "publishedSpecial",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "publishedGeneral",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v15/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "actions",
            "storageKey": null
          },
          (v22/*: any*/),
          (v21/*: any*/),
          (v18/*: any*/),
          {
            "alias": null,
            "args": (v30/*: any*/),
            "concreteType": "ProblemGeneratorHistoryConnection",
            "kind": "LinkedField",
            "name": "histories",
            "plural": false,
            "selections": [
              (v13/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ProblemGeneratorHistoryEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProblemGeneratorHistory",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "type",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "createdBy",
                        "plural": false,
                        "selections": [
                          (v19/*: any*/),
                          (v20/*: any*/),
                          (v6/*: any*/),
                          (v14/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "created",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "difference",
                        "plural": false,
                        "selections": [
                          (v31/*: any*/),
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isDifference"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "generatedCount",
                                "plural": false,
                                "selections": (v32/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "publishedProblemsCount",
                                "plural": false,
                                "selections": (v32/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "ProblemGeneratorDifference",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v31/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "histories(first:10)"
          },
          {
            "alias": null,
            "args": (v30/*: any*/),
            "filters": null,
            "handle": "connection",
            "key": "ProblemGeneratorProblemGeneratorHistoryPaginator_problemGenerator_histories",
            "kind": "LinkedHandle",
            "name": "histories"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6a81d6186d6cc7369d8fe78dc9822345",
    "id": null,
    "metadata": {},
    "name": "ProblemGeneratorId_problemGeneratorQuery",
    "operationKind": "query",
    "text": "query ProblemGeneratorId_problemGeneratorQuery(\n  $id: ID!\n  $filters: ProblemGeneratorFilter\n  $order: ProblemGeneratorOrder\n  $generatedProblemFilters: GeneratedProblemFilter\n  $generatedProblemOrder: GeneratedProblemOrder\n) {\n  problemGenerator(id: $id) {\n    id\n    previous(filters: $filters, order: $order)\n    next(filters: $filters, order: $order)\n    originalTask {\n      id\n      sequence\n      problem {\n        id\n        problem\n        solution\n      }\n      ...TaskDescriptionList_task\n    }\n    generatedProblems(filters: $generatedProblemFilters, order: $generatedProblemOrder) {\n      totalCount\n      edges {\n        node {\n          id\n          task {\n            id\n            sequence\n            isDeleted\n          }\n        }\n      }\n    }\n    ...ProblemGeneratorActionsMutationButtonStack_problemGenerator_2yLmhe\n    ...ProblemGeneratorDescriptionList_problemGenerator\n    ...ProblemGeneratorProblemGeneratorHistoryPaginator_problemGenerator\n    ...ProblemGeneratorGeneratedProblemMutationActionsDialog_problemGenerator\n  }\n}\n\nfragment DiffItem_diff on Diff {\n  before\n  after\n}\n\nfragment ProblemGeneratorActionsMutationButtonStack_problemGenerator_2yLmhe on ProblemGenerator {\n  id\n  actions\n  ...ProblemGeneratorActivateDialog_problemGenerator\n  ...ProblemGeneratorDeactivateDialog_problemGenerator\n  generatedProblems(filters: $generatedProblemFilters, order: $generatedProblemOrder) {\n    totalCount\n  }\n}\n\nfragment ProblemGeneratorActivateDialog_problemGenerator on ProblemGenerator {\n  id\n}\n\nfragment ProblemGeneratorDeactivateDialog_problemGenerator on ProblemGenerator {\n  id\n}\n\nfragment ProblemGeneratorDescriptionList_problemGenerator on ProblemGenerator {\n  id\n  assigned\n  assignedTo {\n    id\n    ...UserAvatarText_user\n  }\n  ...ProblemGeneratorStatusLabel_problemGenerator\n}\n\nfragment ProblemGeneratorDifferenceCounterLabel_difference on Difference {\n  __isDifference: __typename\n  ... on ProblemGeneratorDifference {\n    generatedCount {\n      __typename\n    }\n    publishedProblemsCount {\n      __typename\n    }\n  }\n}\n\nfragment ProblemGeneratorDifferenceItemList_difference on Difference {\n  __isDifference: __typename\n  ... on ProblemGeneratorDifference {\n    generatedCount {\n      ...DiffItem_diff\n    }\n    publishedProblemsCount {\n      ...DiffItem_diff\n    }\n  }\n}\n\nfragment ProblemGeneratorGeneratedProblemMutationActionsDialog_problemGenerator on ProblemGenerator {\n  id\n  actions\n  originalTask {\n    id\n    sequence\n    problem {\n      id\n      problem\n      solution\n      answer\n    }\n    hint {\n      id\n      publishedText\n    }\n    submitFeedback {\n      id\n      publishedSpecialAnswer\n      publishedSpecial\n      publishedGeneral\n    }\n  }\n}\n\nfragment ProblemGeneratorHistoryDialog_problemGeneratorHistory on ProblemGeneratorHistory {\n  createdBy {\n    name\n    picture\n    id\n  }\n  created\n  difference {\n    __typename\n    ...ProblemGeneratorDifferenceCounterLabel_difference\n    ...ProblemGeneratorDifferenceItemList_difference\n  }\n}\n\nfragment ProblemGeneratorHistoryTimelineItem_problemGeneratorHistory on ProblemGeneratorHistory {\n  created\n  createdBy {\n    id\n    ...UserAvatarText_user\n  }\n  type\n}\n\nfragment ProblemGeneratorProblemGeneratorHistoryPaginator_problemGenerator on ProblemGenerator {\n  histories(first: 10) {\n    totalCount\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n    edges {\n      cursor\n      node {\n        id\n        type\n        ...ProblemGeneratorHistoryDialog_problemGeneratorHistory\n        ...ProblemGeneratorHistoryTimelineItem_problemGeneratorHistory\n        __typename\n      }\n    }\n  }\n  id\n}\n\nfragment ProblemGeneratorStatusLabel_problemGenerator on ProblemGenerator {\n  status\n}\n\nfragment TaskDescriptionList_task on Task {\n  id\n  title\n  problem {\n    id\n    problemType\n    creationType\n    answer\n    answerType\n    answerChoiceCount\n  }\n  scrap {\n    id\n    scrapSource {\n      id\n      title\n    }\n  }\n  ...TaskStatusLabel_task\n  assignedTo {\n    id\n    ...UserAvatarText_user\n  }\n  assigned\n  aiFile {\n    id\n    objectUrl\n  }\n  problemGenerator {\n    id\n  }\n  generatedProblem {\n    id\n    problemGenerator {\n      id\n      originalTask {\n        id\n      }\n    }\n  }\n  originalTask {\n    id\n  }\n  isMigrated\n  migrationDifficultyNeedsReview\n  derivedTaskGroups {\n    kind\n    count\n  }\n  migrationPair {\n    id\n  }\n  labelingCount\n  firstLabeling {\n    id\n    difficulty\n    unitDs(order: {order: DESC}) {\n      id\n      unitATitle\n      unitBTitle\n      unitCTitle\n      description\n    }\n  }\n  secondLabeling {\n    id\n    difficulty\n    unitDs(order: {order: DESC}) {\n      id\n      unitATitle\n      unitBTitle\n      unitCTitle\n      description\n    }\n  }\n  finalLabeling {\n    id\n    difficulty\n    unitDs(order: {order: DESC}) {\n      id\n      unitATitle\n      unitBTitle\n      unitCTitle\n      description\n    }\n  }\n  unitDs(order: {order: DESC}) {\n    id\n    unitATitle\n    unitBTitle\n    unitCTitle\n    description\n  }\n  publishedUnitDs(order: {order: DESC}) {\n    id\n    unitATitle\n    unitBTitle\n    unitCTitle\n    description\n  }\n  difficulty\n  aiDifficulty\n  typingAutomationScript {\n    id\n    title\n  }\n}\n\nfragment TaskStatusLabel_task on Task {\n  status\n}\n\nfragment UserAvatarText_user on User {\n  name\n  picture\n  isDeleted\n}\n"
  }
};
})();

(node as any).hash = "7ff04013f370b89e124d9da8bc997b30";

export default node;
